export default {
  // When fetching problems using filters and sorting options, save the configuraiton here,
  // As well as the ids of the problems already fetchd with that configuration.
  // The idea is to have a proper state mgt to not mix all fetched problems in the list.
  // It also allows keeping a proper state when offlineMode is activated.
  // The property key will be the JSON-stringified fetch options, and the
  // value will be an object with the array of problem IDs
  problemsFetchConfigurations: {},
  // DMP problems as { <problem_id>: {problem_data} }
  problems: {},
  // Same behavior as problemsFetchConfigurations
  actionsFetchConfigurations: {},
  // Same behavior as problems
  actions: {},
  causePictures: {},
  // History changes array for problem 47 will be history['47'] = [ change1, change2 ]
  history: {},
  // If history is currently loading for problem 47, historyLoading['47'] = true
  historyLoading: {},
  // Problem creation Log buffer to idnetify the infinite problem creation loop
  creationLogBuffer: '',
  latestProblemCalls: [],
  problemInterruptionModalDisplayed: false,
  interruptProblemCreation: false,
};
